import React from 'react';
import styled from '@emotion/styled';

const IconButtonStyles = styled.div<{ hoverColor?: string; backgroundColor?: string }>`
  align-items: center;
  background-color: ${props => props.backgroundColor};
  color: #444340;
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;
  :hover {
    background-color: #ecf0f1;
    color: ${props => props.hoverColor};
  }
`;

interface Props {
  icon: any;
  hoverColor?: string;
  backgroundColor?: string;
  onClick?: (e?: any) => void;
}
const IconButton = (props: Props) => {
  return (
    <IconButtonStyles
      hoverColor={props.hoverColor}
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      className="iconButtonStyles"
    >
      {props.icon}
    </IconButtonStyles>
  );
};

export default IconButton;
